import ReactPixel from "react-facebook-pixel";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function initPixel() {
    if (!PIXEL_ID) return;
    ReactPixel.init(PIXEL_ID, {}, { autoConfig: true, debug: false });
}

export function trackPageView() {
    if (!PIXEL_ID) return;
    ReactPixel.pageView();
}

export function trackInitiateCheckout(value, items) {
    if (!PIXEL_ID) return;
    ReactPixel.track("InitiateCheckout", {
        value,
        currency: "CLP",
        num_items: items.reduce((sum, i) => sum + i.quantity, 0),
    });
}

export function trackPurchase(value, purchaseId) {
    if (!PIXEL_ID) return;
    ReactPixel.track("Purchase", {
        value,
        currency: "CLP",
        order_id: purchaseId,
    });
}

export function trackAddToCart(product) {
    if (!PIXEL_ID) return;
    ReactPixel.track("AddToCart", {
        content_ids: [String(product.id)],
        content_name: product.name,
        content_type: "product",
        value: product.currentPrice,
        currency: "CLP",
    });
}

export function trackViewContent(products) {
    if (!PIXEL_ID) return;
    ReactPixel.track("ViewContent", {
        content_ids: products.map((p) => String(p.id)),
        content_type: "product",
        num_items: products.length,
    });
}

export function trackSearch(query) {
    if (!PIXEL_ID) return;
    ReactPixel.track("Search", { search_string: query });
}

export function trackAddPaymentInfo() {
    if (!PIXEL_ID) return;
    ReactPixel.track("AddPaymentInfo");
}

export function trackContact() {
    if (!PIXEL_ID) return;
    ReactPixel.track("Contact");
}
